import { DatastoreProvider } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { Stack, useLocalSearchParams } from 'expo-router';
import { rankingEvalModuleQuery, useModule } from 'system/structure-modules';

export default function RankingEvalSideBySideScreen() {
    const { instanceKey, siloKey } = useLocalSearchParams<'/[siloKey]/ranking-eval/one/side-by-side/[instanceKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'ranking-eval',
        instanceKey,
        moduleQuery: rankingEvalModuleQuery,
    });
    const { SideBySideScreen } = useModule(rankingEvalModuleQuery);

    return (
        <>
            <Stack.Screen options={{ title: instanceKey }} />
            <DatastoreProvider {...instanceConfig}>
                <SideBySideScreen />
            </DatastoreProvider>
        </>
    );
}
